import api from "@/services/api";

const _http = {
  async getAll(params = {}) {
    return api.get("/transport-offers", { params });
  },
  getById(id) {
    return api.get(`/transport-offers/${id}`);
  },
  getFiles(id) {
    return api.get(`/transport-offers/${id}/files`);
  },
  updateFileStatus(offerId, fileId, status) {
    return api.put(
      `/transport-offers/${offerId}/file-status/${fileId}`,
      { status },
    );
  },
  getSignedUrl(key) {
    return api.get("/s3-signed-url", { params: { key } });
  },
  create(data) {
    const isFormData = data instanceof FormData;
    return api.post("/transport-offers", data, {
      headers: isFormData ? { "Content-Type": "multipart/form-data" } : {},
      timeout: isFormData ? 60000 : 10000,
    });
  },
  update(id, data) {
    const isFormData = data instanceof FormData;
    return api.put(`/transport-offers/${id}`, data, {
      headers: isFormData ? { "Content-Type": "multipart/form-data" } : {},
      timeout: isFormData ? 60000 : 10000,
    });
  },
};




export default {
  async getAll(query = {}) {
    try {
      const res = await _http.getAll(query);
      return {
        data: res.data.data.map((item) => item),
        total: res.data.total || 0,
        expired: res.data.expired || 0,
      };
    } catch (error) {
      console.error(error);
      return {
        data: [],
        total: 0,
        expired: 0,
      };
    }
  },

  async getById(id) {
    try {
      const [detailRes, filesRes] = await Promise.allSettled([
        _http.getById(id),
        _http.getFiles(id),
      ]);

      if (detailRes.status !== "fulfilled") throw detailRes.reason;

      const files =
        filesRes.status === "fulfilled" ? filesRes.value.data.data || [] : [];

      return {
        ...detailRes.value.data.data,
        files,
      };
    } catch (error) {
      console.error(error);
      return null;
    }
  },

  async updateFileStatus(offerId, fileId, status) {
    try {
      const res = await _http.updateFileStatus(
        offerId,
        fileId,
        status,
      );
      return res.data;
    } catch (error) {
      console.error("Error updating file status:", error);
      throw error;
    }
  },

  async getSignedUrl(key) {
    try {
      const res = await _http.getSignedUrl(key);
      return res.data; // { success: true, url: "..." }
    } catch (error) {
      console.error("Error getting signed URL:", error);
      throw error;
    }
  },

  async create(payload) {
    try {
      const response = await _http.create(payload);
      return response;
    } catch (error) {
      console.error("Error creating document:", error);
      throw error;
    }
  },

  async update(id, payload) {
    return await _http.update(id, payload);
  },
};

